import React from 'react';
import { ArrowRight } from 'lucide-react';
import { scrollToSection } from '../../utils/scroll';
const navLinks = [{
  label: 'Shop',
  id: 'bundles'
}, {
  label: 'Our story',
  id: 'worlds'
}, {
  label: 'The mask',
  id: 'mask'
}, {
  label: 'Reviews',
  id: 'reviews'
}, {
  label: 'As seen in',
  id: 'featured'
}, {
  label: 'FAQ',
  id: 'faq'
}];
export function BrandHeader() {
  return <>
      <div className="border-b border-gunmetal/60 bg-carbon" data-id="element-41" data-mp="3ulu1eyx6taz">
        <p className="mx-auto max-w-7xl px-5 py-2 text-center text-[11px] font-medium uppercase tracking-[0.18em] text-bone/85" data-id="element-42" data-mp="3wyblr0rn1ni">
          <span className="sm:hidden" data-id="element-43" data-mp="cwbmmo4jfyac">Buy 2, get 1 free · Free shipping on 3+</span>
          <span className="hidden sm:inline" data-id="element-44" data-mp="7wp7g955g7yw">
            Issue 01 // Nocturne · Buy 2, get 1 free · Free U.S. shipping on bundles of 3+
          </span>
        </p>
      </div>

      <header className="sticky top-0 z-40 border-b border-gunmetal/60 bg-obsidian/90 backdrop-blur-md" data-id="element-45" data-mp="2ep9ae5jgk0of">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 md:px-8" data-id="element-46" data-mp="29qg5v2m5fk0e">
          <a href="#top" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="leading-none" aria-label="BLACKOUT UNIT home" data-id="element-47" data-mp="10vcbw9dfj28y">
            <span className="block whitespace-nowrap font-display text-[22px] uppercase tracking-[0.04em] text-bone md:text-2xl" data-id="element-48" data-mp="1fnmif3l144bq">
              Blackout Unit<span className="ml-0.5 align-top text-[10px]" data-id="element-49" data-mp="1omhp0grzjgfk">™</span>
            </span>
            <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.42em] text-steel" data-id="element-50" data-mp="1tlunxzw4sdyi">
              More than a mask
            </span>
          </a>

          <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-51" data-mp="1ykfflaxbhpbc">
            {navLinks.map(link => <button key={link.id} type="button" onClick={() => scrollToSection(link.id)} className="text-[12px] font-medium uppercase tracking-[0.16em] text-steel transition-colors duration-150 hover:text-bone" data-id="element-52" data-mp="3vfk82uch2i3x">
                {link.label}
              </button>)}
          </nav>

          <button type="button" onClick={() => scrollToSection('bundles')} className="group inline-flex h-10 shrink-0 items-center gap-2 whitespace-nowrap bg-bone px-5 text-[12px] font-semibold uppercase tracking-[0.14em] text-obsidian transition-[background-color,transform] duration-150 ease-out hover:bg-white active:scale-[0.98]" data-id="element-53" data-mp="65pjsdifvaou">
            Build your unit
            <ArrowRight className="hidden h-3.5 w-3.5 sm:block" aria-hidden="true" data-id="element-54" data-mp="owytams7lzgf" />
          </button>
        </div>
      </header>
    </>;
}